import { CustomError } from "ts-custom-error";

export class UnknownEyeCheckCode extends CustomError {}
export class InvalidQueryParameters extends CustomError {}
